import { render, staticRenderFns } from "./NoteToc.vue?vue&type=template&id=1148d922&scoped=true&"
import script from "@/scripts/Notes/NoteDetail/components/NoteToc.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NoteDetail/components/NoteToc.js?vue&type=script&lang=js&"
import style0 from "./NoteToc.vue?vue&type=style&index=0&id=1148d922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1148d922",
  null
  
)

export default component.exports